import { Link } from 'react-router-dom';

const navigation = {
  company: [
    { name: 'About', href: '/about' },
    { name: 'Case Studies', href: '/case-studies' },
    { name: 'Careers', href: '/careers' },
    { name: 'Internship Program', href: '/internship'}
  ],
  services: [
    { name: 'Marketplace Integration', href: '/services' },
    { name: 'Logistics & Fulfillment', href: '/services' },
    { name: 'Payment Solutions', href: '/services' }
  ],
  resources: [
    { name: 'Case Studies', href: '/case-studies' },
    { name: 'Blog', href: '/blog' },
    { name: 'Documentation', href: '/docs' }
  ],
  legal: [
    { name: 'Privacy', href: '/privacy' },
    { name: 'Terms', href: '/terms' }
  ]
};

export default function Footer() {
  return (
    <footer className="bg-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {Object.entries(navigation).map(([category, items]) => (
            <div key={category}>
              <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
                {category.charAt(0).toUpperCase() + category.slice(1)}
              </h3>
              <ul className="mt-4 space-y-4">
                {items.map((item) => (
                  <li key={item.name}>
                    <Link to={item.href} className="text-base text-gray-500 hover:text-gray-900">
                      {item.name}
                      {item.badge && (
                        <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                          {item.badge}
                        </span>
                      )}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-8 border-t border-gray-200 pt-8">
          <p className="text-base text-gray-400 text-center">
            &copy; {new Date().getFullYear()} SellAbroad.io. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}